import React from 'react'
import { useNavigate } from 'react-router-dom'

import Header from '@pages/companies/header'
import ArrowBack from '@components/arrowBack'
import Title from '@components/text/title'
import MessagesTable from '@components/table/messagesTable'

import {
  Container, TitleContainer
} from './styles'

const MessagesDetail = () => {
  const navigate = useNavigate()
  return (
    <Container>
      <Header />
      <TitleContainer>
        <ArrowBack onClick={() => { navigate(-1) }} />
        <Title>Histórico de mensagens</Title>
      </TitleContainer>
      <MessagesTable />
    </Container>
  )
}

MessagesDetail.propTypes = {
}

export default MessagesDetail
